import type React from "react"
import "./common-popup.css"
import { ReactNode } from "react";
import { GetImages } from "../../utils/GetImages";

interface CommonpopupProps {
  isOpen?: boolean
  onClose?: () => void
  component?: ReactNode;
}

const Commonpopup: React.FC<CommonpopupProps> = ({
  isOpen,
  onClose,

  component,
}) => {
  if (!isOpen) return null

  
  return (
    <div id="error500" className="error-overlay">
      <div className="error-popup">
        <button className="close-button" onClick={onClose}>
        <img src={GetImages.Blackcross} alt="Close" width={16} height={16} />
        </button>

        {component}

       
      </div>
    </div>
  )
}

export default Commonpopup
